import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export default function PageTransition() {
  const location = useLocation();
  const [isFlashing, setIsFlashing] = useState(false);

  useEffect(() => {
    setIsFlashing(true);
    const timer = setTimeout(() => {
      setIsFlashing(false);
    }, 650);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <div
      className={`fixed inset-0 z-[9999] pointer-events-none flex items-center justify-center transition-opacity ${
        isFlashing ? 'opacity-100' : 'opacity-0'
      }`}
      style={{
        background: 'linear-gradient(135deg, #df862c 0%, #c06a18 100%)',
        transitionDuration: isFlashing ? '0ms' : '400ms',
      }}
    >
      <div
        className={`flex items-center justify-center rounded-full bg-white transition-all ${
          isFlashing ? 'opacity-100 scale-100' : 'opacity-0 scale-75'
        }`}
        style={{
          width: '120px',
          height: '120px',
          transitionDuration: isFlashing ? '200ms' : '300ms',
        }}
      >
        <div className="w-16 h-16 flex items-center justify-center">
          <i className="ri-building-4-line text-5xl text-[#df862c]"></i>
        </div>
      </div>
    </div>
  );
}
